/**
 * Các options khi chọn tại combobox Tổng hợp của form tham số báo cáo
 * nvthinh 15.07.2024
 * đổi vị trí cho đúng thứ tự
 * htthoa 24.7.2024
 */
export default {
  AllDistrict: 2,
  District: 1,
  Ward: 0,
};
